import { hexToBinary, toUserId, toUserIdRaw, wait } from '@streamr/utils';
import { BrowserProvider } from 'ethers';
import { pLimitFn } from '../utils/promises';
import { Identity } from './Identity';
import { SignatureType } from '@streamr/trackerless-network';
/**
 * An identity that uses an Ethereum provider (= external wallet) to sign messages
 */
export class EthereumProviderIdentity extends Identity {
    provider;
    expectedChainId;
    signer;
    cachedUserIdString;
    cachedUserIdBytes;
    rateLimitedSigner;
    constructor(provider, expectedChainId) {
        super();
        this.provider = provider;
        this.expectedChainId = expectedChainId;
        this.signer = provider.getSigner();
        this.rateLimitedSigner = pLimitFn(async (payload) => {
            // sign one at a time & wait a moment before asking for next signature
            // otherwise MetaMask extension may not show the prompt window
            const sig = await (await this.signer).signMessage(payload);
            await wait(50);
            return hexToBinary(sig);
        }, 1);
    }
    async getUserIdRaw() {
        this.cachedUserIdBytes ??= toUserIdRaw(await this.getUserId());
        return this.cachedUserIdBytes;
    }
    async getUserId() {
        this.cachedUserIdString ??= toUserId(await (await this.signer).getAddress());
        return this.cachedUserIdString;
    }
    // eslint-disable-next-line class-methods-use-this
    getSignatureType() {
        return SignatureType.ECDSA_SECP256K1_EVM;
    }
    async createMessageSignature(payload) {
        return this.rateLimitedSigner(payload);
    }
    async getTransactionSigner() {
        if (this.expectedChainId === undefined) {
            throw new Error('Streamr chainId not configuredin the StreamrClient options!');
        }
        const actualChainId = (await this.provider.getNetwork()).chainId;
        if (actualChainId !== BigInt(this.expectedChainId)) {
            throw new Error(`Connect your wallet to the chain with chainId ${this.expectedChainId} (chainId of currently selected chain is ${actualChainId})`);
        }
        return this.signer;
    }
    /** @internal */
    static fromConfig(config) {
        const ethereum = config.auth?.ethereum;
        const provider = new BrowserProvider(ethereum);
        return new EthereumProviderIdentity(provider, config.contracts.ethereumNetwork.chainId);
    }
}
//# sourceMappingURL=EthereumProviderIdentity.js.map